<template>
  <b-card>
    <b-card-title class="d-flex justify-content-between align-items-center">
      <h2>Phone number approval</h2>
      <h4
        v-if="errMessage"
        class="text-danger"
      >
        {{ errMessage }}
      </h4>
    </b-card-title>
    <base-overlay :show="loading">
      <hr>
      <template v-if="!loading">
        <PhoneDetailsForm
          v-for="item in data"
          :key="item.id"
          :data="item"
          :user="user"
          @submitted="fetchPhones"
        />
      </template>
    </base-overlay>
  </b-card>
</template>

<script>
import { BCard, BCardTitle } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import PhoneDetailsForm from './PhoneDetailsForm.vue'

export default {
  components: {
    BCard, BCardTitle, PhoneDetailsForm,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    const loading = ref(false)
    const data = ref(null)
    const errMessage = ref(null)
    const showForm = ref(false)
    const fetchPhones = async () => {
      loading.value = true
      errMessage.value = null
      data.value = null
      try {
        data.value = await ctx.root.$store.dispatch('users/fetchUserPhones', {
          id: props.user.id,
        })
      } catch (error) {
        errMessage.value = error?.response?.data?.error?.message
      } finally {
        loading.value = false
      }
    }
    fetchPhones()
    return {
      fetchPhones,
      loading,
      data,
      errMessage,
      showForm,
    }
  },
}
</script>
